import * as React from 'react';
import * as _ from 'underscore';

import SelectField from './SelectField';
import DateField from './DateField';
import NumberField from './NumberField';
import StringField from './StringField';

import { nullHandlingBehaviour, useReplacingType } from '../ts/nullHandling';
import RadioGroupFieldComponent from './RadioGroupField';

interface IReplaceNullValuesFieldState {
    value: any;
}

export class ReplaceNullValuesField extends React.Component<
    {
        value?: any;
        title?: string;
        options?: {
            type: string;
            title?: string;
        };
        onChange?(value: any);
    },
    IReplaceNullValuesFieldState
> {
    static defaultReplacingType = useReplacingType.USE_OWN;

    constructor(props) {
        super(props);

        let value = this.normalizeValue(this.props.value);

        this.state = {
            value: value
        };
    }

    normalizeValue(value) {
        return value;
    }

    componentDidMount() {}

    componentWillReceiveProps(newProps) {
        const newValue = this.normalizeValue(newProps.value);

        if (newValue !== this.state.value) {
            this.setState({ value: newValue });
        }
    }

    processReplacingRadioGroupChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.replacingType = val;
        //this.setState({ value: val } as IReplaceNullValuesFieldState);
        this.setState({ value: obj });
        this.handleChange(obj);
    };

    byStringValueChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.byStringValue = val;
        this.setState({ value: obj });
        this.handleChange(obj);
    };

    byOwnValueChange = (val) => {
        let obj = _.clone(this.state.value || {});
        obj.byOwnValue = val;
        this.setState({ value: obj });
        this.handleChange(obj);
    };

    handleChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    static COMP_NUM = 0;
    static RG_NUM = 0;

    render() {
        const title =
            this.props.title != null ? this.props.title : (this.props.options && this.props.options.title) || '';

        //LL: set new key each time, otherwise React does not apply changes of input-radio, defaultCheck does not help
        //ReplaceNullValuesField.COMP_NUM++;  //LL:  NO !!
        ReplaceNullValuesField.RG_NUM++;

        let typeOwn;
        if (this.props.options != null && this.props.options.type != null) {
            typeOwn = this.props.options.type;
        }

        let typeV = 'not set';
        if (typeOwn != null) {
            typeV = typeOwn;
            if (typeOwn === 'numeric') {
                typeV = 'number';
            }
        }

        let typeName = typeV.charAt(0).toUpperCase() + typeV.slice(1);

        // - RadioGroup:

        let styleReplacingType: any = {
            marginTop: '10px',
            marginBottom: '10px'
        };

        let displayReplacingType = ReplaceNullValuesField.defaultReplacingType;
        if (this.state.value != null && this.state.value.replacingType != null) {
            displayReplacingType = this.state.value.replacingType;
        }

        // text: "Default by Widget"  or "Widget Default", "Widget's Type Default", "Use Default for Widget Type"  // Kind ?
        let rgItems = [
            { text: 'as ' + typeName, value: useReplacingType.USE_OWN },
            { text: 'as String', value: useReplacingType.USE_STRING }
        ];

        let rgOptions = {
            name: 'RG_ReplacingType_' + ReplaceNullValuesField.RG_NUM, //LL: needed to differ RadioGroup from other RadioGroups
            layout: 'horizontal',
            items: rgItems
            //displayField?: string;  //    default "text"
            //valueField?: string;   //    default "value"
        };
        let elemRG = (
            <div style={styleReplacingType}>
                <label>
                    <span>{'Replacing value Type: '}</span>
                </label>
                <RadioGroupFieldComponent
                    value={displayReplacingType}
                    options={rgOptions}
                    onChange={this.processReplacingRadioGroupChange}
                />
            </div>
        );

        // -- Replacement by Own type

        let byOwnElem;

        let showByOwnValue = displayReplacingType !== useReplacingType.USE_STRING;

        if (showByOwnValue) {
            let displayByOwnValue: any = '';
            switch (typeOwn) {
                case 'numeric':
                    displayByOwnValue = 0;
                    break;
                case 'date':
                    //displayByOwnValue = (new Date(0)).toDateString();
                    displayByOwnValue = new Date(0);
                    break;
                case 'boolean':
                    displayByOwnValue = 'false';
                    break;
            }

            if (this.state.value != null && this.state.value.byOwnValue != null) {
                displayByOwnValue = this.state.value.byOwnValue;
            }

            let byOwnElemEdit;

            switch (typeOwn) {
                case 'numeric':
                    byOwnElemEdit = <NumberField value={displayByOwnValue} onChange={this.byOwnValueChange} />;
                    break;

                case 'date':
                    //  hideClearButton={ true }
                    //LL: type = 'date' - for dxDateBox
                    //LL: displayDateFormat or displayDateTimeFormat for displayFormat in dxDateBox,  (displayFormat: "EEEE, MMM dd",)
                    //        "shortDate" is default for Date - "1/25/1970"
                    //
                    //LL:  dx-texteditor-input: padding: 7px 9px 8px;   set in sass:
                    //        input.dx-texteditor-input
                    //            padding-top: 1px
                    //            padding-bottom: 1px
                    //            padding-left: 1px
                    byOwnElemEdit = (
                        <DateField
                            value={displayByOwnValue}
                            onChange={this.byOwnValueChange}
                            type={'date'}
                            displayDateFormat={'yyyy-MM-dd'}
                            hideClearButton={true}
                        />
                    );
                    break;

                case 'boolean':
                    let opt = {
                        //values: [true, false],
                        values: ['true', 'false'],
                        display: ['true', 'false']
                    };
                    byOwnElemEdit = (
                        <SelectField value={displayByOwnValue} onChange={this.byOwnValueChange} options={opt} />
                    );
                    break;
            }

            let styleByOwn: React.CSSProperties = {
                width: '130px',
                display: 'inline-block'
            };
            //  , verticalAlign: "top"
            //LL:  for "inline-block" default verticalAlign = baseline
            if (typeOwn === 'date') {
                styleByOwn.verticalAlign = 'top';
            }

            byOwnElem = (
                <div style={styleByOwn}>
                    <label>
                        <span>by {typeName}: </span>
                    </label>
                    {byOwnElemEdit}
                </div>
            );
        }

        // -- Replacement by String

        let byStringElem;
        let showByStringValue = displayReplacingType !== useReplacingType.USE_OWN;

        if (showByStringValue) {
            let displayByStringValue = '';

            if (this.state.value != null && this.state.value.byStringValue != null) {
                displayByStringValue = this.state.value.byStringValue;
            }

            let styleByString: React.CSSProperties = {
                width: '200px',
                marginLeft: '15px',
                display: 'inline-block'
            };
            //  , verticalAlign: "top"

            byStringElem = (
                <div style={styleByString}>
                    <label>
                        <span>{'by String: '}</span>
                    </label>
                    <StringField value={displayByStringValue} onChange={this.byStringValueChange} />
                </div>
            );
        }

        // --

        let styleReplacingValues = { marginLeft: '5px' };

        return (
            <div
                className="replacenullvalues-field"
                id={'rg_' + ReplaceNullValuesField.COMP_NUM}
                key={'rg_' + ReplaceNullValuesField.COMP_NUM}
                title={title}
            >
                {elemRG}
                <div style={styleReplacingValues}>
                    {byOwnElem}
                    {byStringElem}
                </div>
            </div>
        );
    }
}
